var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 2C10.1266 2 8 4.12665 8 6.75C8 9.37335 10.1266 11.5 12.75 11.5C15.3734 11.5 17.5 9.37335 17.5 6.75C17.5 4.12665 15.3734 2 12.75 2ZM9.5 6.75C9.5 4.95507 10.9551 3.5 12.75 3.5C14.5449 3.5 16 4.95507 16 6.75C16 8.54493 14.5449 10 12.75 10C10.9551 10 9.5 8.54493 9.5 6.75Z",
    fill: "#341439"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 13C7.12665 13 5 15.1266 5 17.75C5 20.3734 7.12665 22.5 9.75 22.5H15.75C18.3734 22.5 20.5 20.3734 20.5 17.75C20.5 15.1266 18.3734 13 15.75 13H9.75ZM6.5 17.75C6.5 15.9551 7.95507 14.5 9.75 14.5H15.75C17.5449 14.5 19 15.9551 19 17.75C19 19.5449 17.5449 21 15.75 21H9.75C7.95507 21 6.5 19.5449 6.5 17.75Z",
    fill: "#341439"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.aca697314931c5fa9ab746f79e7bbf3b.svg";
export { ForwardRef as ReactComponent };